module.exports = __webpack_public_path__ + "media/images/icons/illustration/signup-6bbdd648f0870a92f78c62652318e3cd.svg";